import { useEffect, useState } from 'react';
import css from './TelaDeEntrada.module.css';

// O mesmo bairro visto de cima das telas de entrada dos apps (ui-native/MapaDeFundo): a rota se
// desenha e a moto vai até o pino. Animação em SVG nativo; parada com "reduzir movimento".
const ROTA = 'M70 450 C90 390 60 350 120 312 C180 274 210 280 214 228 C218 176 268 160 318 146';
const QUADRAS = [
  [-40, -30, 120, 90],
  [100, -30, 110, 90],
  [230, -30, 200, 90],
  [-40, 90, 120, 110],
  [100, 90, 110, 50],
  [100, 150, 110, 50],
  [230, 90, 90, 110],
  [340, 90, 90, 110],
  [-40, 230, 120, 120],
  [100, 230, 220, 120],
  [340, 230, 90, 120],
  [-40, 380, 200, 120],
  [180, 380, 250, 120],
] as const;

function useReduzirMovimento() {
  const [reduzir, setReduzir] = useState(
    () => window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ?? false,
  );
  useEffect(() => {
    const consulta = window.matchMedia?.('(prefers-reduced-motion: reduce)');
    if (!consulta) return;
    const ouvir = () => setReduzir(consulta.matches);
    consulta.addEventListener('change', ouvir);
    return () => consulta.removeEventListener('change', ouvir);
  }, []);
  return reduzir;
}

export function MapaDeFundo() {
  const animar = !useReduzirMovimento();
  return (
    <svg
      className={css.svgMapa}
      viewBox="0 0 390 430"
      preserveAspectRatio="xMidYMid slice"
      aria-hidden="true"
    >
      <g transform="rotate(-12 195 215)">
        {QUADRAS.map(([x, y, w, h]) => (
          <rect key={`${x}-${y}`} x={x} y={y} width={w} height={h} rx="10" className={css.quadra} />
        ))}
        <path
          d="M-60 75 H460 M-60 215 H460 M-60 365 H460 M90 -60 V520 M220 -60 V520 M330 -60 V520"
          className={css.rua}
        />
        <path d="M-60 145 H220 M160 380 V520 M380 90 V230" className={css.ruaFina} />
      </g>
      <path d={ROTA} className={css.rotaBrilho} />
      <path
        d={ROTA}
        className={css.rota}
        pathLength={1}
        strokeDasharray="1"
        strokeDashoffset={animar ? 1 : 0}
      >
        {animar && (
          <animate
            attributeName="stroke-dashoffset"
            values="1;0;0"
            keyTimes="0;0.7;1"
            dur="5s"
            repeatCount="indefinite"
          />
        )}
      </path>
      <circle cx="318" cy="146" r="10" className={css.pulso}>
        {animar && (
          <>
            <animate attributeName="r" values="10;26;10" dur="2s" repeatCount="indefinite" />
            <animate
              attributeName="opacity"
              values="0.45;0;0.45"
              dur="2s"
              repeatCount="indefinite"
            />
          </>
        )}
      </circle>
      <circle cx="318" cy="146" r="9" className={css.pino} />
      <g transform={animar ? undefined : 'translate(318 146)'}>
        {animar && (
          <animateMotion
            dur="5s"
            repeatCount="indefinite"
            keyPoints="0;1;1"
            keyTimes="0;0.7;1"
            calcMode="linear"
            path={ROTA}
          />
        )}
        <circle r="14" className={css.moto} />
        <circle r="4" className={css.motoCentro} />
      </g>
    </svg>
  );
}
